// extracted by mini-css-extract-plugin
export default {"box":"SocialLinks_box__IXqxE","iconLink":"SocialLinks_iconLink__LumbC"};